module.exports = __webpack_public_path__ + "media/images/landkit/screenshots/landkit/account/error-illustration-9f7d41fe3f72b4af22a121133b26541f.jpg";